import React from "react";

type PaymentSectionProps = {
  isOpen: boolean;
  children: React.ReactNode;
};

const PaymentSection = ({ isOpen, children }: PaymentSectionProps) => {
  return <div>{isOpen && children}</div>;
};

export default PaymentSection;
